import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'
import { grey } from '@mui/material/colors'

import { HandleOpenModalType } from './Types'

interface propsTypes {
  handleOpenModal: HandleOpenModalType
}

const EditIcon = (props: propsTypes) => {
  const { handleOpenModal } = props
  return (
    <ModeEditOutlinedIcon
      sx={{
        cursor: 'pointer',
        color: grey[600],
        fontSize: '1.25rem',
      }}
      onClick={handleOpenModal}
    />
  )
}

export default EditIcon
